import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function SilentSymptomsSection() {
  const symptoms = ['Sock marks that linger after a normal day', 'Puffy face in the morning', 'Random bloating even when you ate “fine”', 'Feeling heavy, inflamed, or stuck', 'Clothes fitting differently week to week'];
  return <section className="py-24 bg-[#F9FAFB]" data-id="element-218">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-220">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-221">
            <span className="text-red-500 font-bold uppercase tracking-wider text-sm flex items-center gap-2" data-id="element-222">
              <AlertCircle className="w-4 h-4" data-id="element-223" />
              If You Relate to Any of These…
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mt-4 mb-6" data-id="element-224">
              This is probably not fat.
            </h2>
            <p className="text-xl text-[#374151] mb-8" data-id="element-225">
              It’s often fluid + puffiness your body isn’t clearing efficiently.
            </p>

            <div className="space-y-6" data-id="element-226">
              <p className="font-bold text-[#1B5E20] text-lg" data-id="element-227">
                Do you ever notice:
              </p>
              <ul className="space-y-4" data-id="element-228">
                {symptoms.map((symptom, i) => <li key={i} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-229">
                    <div className="w-2 h-2 rounded-full bg-red-400 flex-shrink-0" data-id="element-230" />
                    <span className="text-[#374151] font-medium" data-id="element-231">
                      {symptom}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-10" data-id="element-232">
              <p className="text-2xl font-bold text-[#1B5E20]" data-id="element-233">
                You’re not crazy.
              </p>
              <p className="text-xl text-[#10B981] font-medium" data-id="element-234">
                And you’re definitely not alone.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-235">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-236">
              <img src="https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&q=80&w=1000" alt="Woman checking face in mirror" className="w-full h-auto object-cover" data-id="element-237" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-end p-8" data-id="element-238">
                <p className="text-white font-medium italic text-lg" data-id="element-239">
                  "I thought I gained weight overnight... turns out it was just
                  water."
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}